<template>
	<div class="trip-comparison"></div>
</template>

<script>
export default {
	props: [],
	data: function() {
		return {}
	},
	mounted: function() {
	},
	computed: {},
	methods: {}
}
</script>